var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.6 5.2c-.2-.9-.9-1.5-1.7-1.8C16.3 3 10 3 10 3s-6.3 0-7.9.5c-.8.2-1.5.9-1.7 1.7C0 6.8 0 10 0 10s0 3.2.4 4.8c.2.9.9 1.5 1.7 1.8 1.6.4 7.9.4 7.9.4s6.3 0 7.9-.5c.8-.2 1.5-.9 1.7-1.7.4-1.6.4-4.8.4-4.8s0-3.2-.4-4.8M8 13V7l5.2 3z"
  })));
};
export default SvgYoutube;